import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a church wall cross authored at its true mounting
// height (centred around y = 1.8), flat against the wall at z = 0, facing +Z.
// Two walnut bars with a thin muted-gold trim edge proud of the face.
const WOOD = "#7a5a3a";
const TRIM = "#b8963f";

export const wallCrucifix = defineModel({
  id: "wall-crucifix",
  batchId: "modern",
  name: "Wall crucifix",
  tags: ["modern", "interior", "decor", "church", "religious", "wall-mounted"],
  summary: "A walnut wall cross with a thin gold trim edge.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // vertical bar (centred on y = 1.8)
      { geometry: new THREE.BoxGeometry(0.09, 0.9, 0.05), color: WOOD, position: [0, 1.8, 0.025] },
      // horizontal bar (above centre)
      { geometry: new THREE.BoxGeometry(0.55, 0.09, 0.05), color: WOOD, position: [0, 1.98, 0.025] },
      // thin gold trim proud of the face
      { geometry: new THREE.BoxGeometry(0.03, 0.9, 0.01), color: TRIM, position: [0, 1.8, 0.055] },
      { geometry: new THREE.BoxGeometry(0.55, 0.03, 0.01), color: TRIM, position: [0, 1.98, 0.055] },
    ];
  },
  animations: [],
});
